import ErrorPage from '@/components/Error/ErrorPage/ErrorPage';
import { AppLayout } from './AppLayout';
import type { RootErrorDescriptor } from './types';
import { tw } from '@/lib/tailwind';

export const RootErrorView = ({ status, message, onRetry, label }: RootErrorDescriptor) => (
  <AppLayout>
    <ErrorPage
      status={status}
      message={message}
    >
      <button
        onClick={onRetry}
        className={tw('text-primary-700 cursor-pointer border-0 bg-none p-0')}
        aria-label={label}
      >
        {label}
      </button>
    </ErrorPage>
  </AppLayout>
);
